/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import ecLogo from "@/assets/ECLogoWithProviderTrust.png"

export default data => ({
  tableSetting: {
    showHeader: "firstPage",
    theme: "plain",
    margin: 30,
    styles: { overflow: "linebreak" }
  },
  contents: [
    {
      type: "image",
      data: ecLogo,
      width: 13,
      height: 2
    },
    {
      type: "text",
      data: data.clientName,
      align: "right",
      marginY: -2
    },
    {
      type: "text",
      data: `Report run ${data.reportDate}`,
      align: "right"
    },
    {
      type: "text",
      data: data.title,
      fontSize: 1.5,
      fontType: "bold",
      marginY: 2
    },
    {
      type: "text",
      data: data.subtitle,
      fontSize: 1.2,
      marginY: 0.5
    },
    {
      type: "table",
      data: data.summary,
      marginY: 2,
      tableSetting: {
        tableWidth: "wrap"
      }
    },
    {
      type: "table",
      data: data.detail,
      marginY: 2,
      tableSetting: {
        theme: "striped"
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/service/pdfreport/ecPDFTemplate.js